import React, { useMemo, useState } from 'react';
import { RMC_ASSISTANT_DRAWER } from 'src/constants/featureFlags';
import { useFeatureFlags } from 'src/routes/featureFlagsContext';
import { AssistantDrawerProvider } from './AssistantDrawerContext';
import { useAssistantDrawerShortcut } from 'src/lib/hooks/useAssistantDrawerShortcut';

export const AssistantDrawerProviderController = ({ children }: { children: React.ReactNode }) => {
    const { featureFlags } = useFeatureFlags();
    const enabled = featureFlags.includes(RMC_ASSISTANT_DRAWER);
    const [isOpen, setIsOpen] = useState(false);
    const [conversationActive, setConversationActive] = useState(false);

    // useMemo required - context value passed to provider.
    // Without memoization, new object every render causes all consumers to re-render.
    const api = useMemo(
        () => ({
            open: () => enabled && setIsOpen(true),
            close: () => enabled && setIsOpen(false),
            toggle: () => enabled && setIsOpen((o) => !o),
            isOpen,
            isEnabled: enabled,
            conversationActive,
            setConversationActive,
        }),
        [enabled, isOpen, conversationActive],
    );

    const ShortcutBinder = () => {
        useAssistantDrawerShortcut();
        return null;
    };

    return (
        <AssistantDrawerProvider value={api}>
            <ShortcutBinder />
            {children}
        </AssistantDrawerProvider>
    );
};

export default AssistantDrawerProviderController;
